module.exports = __webpack_public_path__ + "fonts/baronsans-hairline-webfont.f3c8789c.woff";